import { ISelectDgtxKetQuaRequest } from "../../../../models/request/danh-gia/thuong-xuyen/ISelectDgtxKetQuaRequest";
import { IHocSinhSelectRequest } from "../../../../models/request/hoc-sinh/IHocSinhSelectRequest";
import { IDgtxKetQua } from "../../../../models/response/danh-gia/thuong-xuyen/IDgtxKetQua";
import { ISoNhanXetItem } from "../../../../models/response/dgdk-dm/ISoNhanXetItem";
import { IHocSinhSelectResponeItem } from "../../../../models/response/hoc-sinh/IHocSinhSelectRespone";
import { generateActionTypeIds } from "../../generateActionTypeIds";
import IGenericActionType from "../../IGenericActionType";

export const eDgTuanKetQuaDefine = {
    CHANGE_FILER: {} as ISelectDgtxKetQuaRequest,

    SO_NHAN_XET_ITEM_LOAD_START: 0,
    SO_NHAN_XET_ITEM_LOAD_SUCCESS: [] as ISoNhanXetItem[],
    SO_NHAN_XET_ITEM_LOAD_ERROR: "",

    KET_QUA_LOAD_START: {} as ISelectDgtxKetQuaRequest,
    KET_QUA_LOAD_SUCCESS: [] as IDgtxKetQua[],
    KET_QUA_LOAD_ERROR: "",

    HOC_SINH_LOAD_START: {} as IHocSinhSelectRequest,
    HOC_SINH_LOAD_SUCCESS: [] as IHocSinhSelectResponeItem[],
    HOC_SINH_LOAD_ERROR: "",

    SAVE_KETQUA_START: {} as IDgtxKetQua,
    SAVE_KETQUA_SUCCESS: {} as IDgtxKetQua,
    SAVE_KETQUA_ERROR: "",
}
export const eDgTuanKetQuaActionTypeIds = generateActionTypeIds(eDgTuanKetQuaDefine, "DG_TUAN")
export type IDgTuanKetQuaActionTypes = IGenericActionType<typeof eDgTuanKetQuaDefine, "DG_TUAN">